import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diversify-icon',
  templateUrl: './diversify-icon.component.html',
  styles: []
})
export class DiversifyIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
